import React from 'react'
import { observer } from 'mobx-react-lite'

import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { TabContentContainer, useGlobalCopyStore } from '../../../../common'

import AccountDetailsTab from './AccountDetailsTab'
import ConnectionErrorMessage from './ConnectionErrorMessage'
import TransactionsTab from '../Transactions/TransactionsTab'

const AccountDetailsContent = () => {
  const [tabValue, setTabValue] = React.useState(0)

  const { accounts: accountsCopy } = useGlobalCopyStore()

  return (
    <>
      <ConnectionErrorMessage setTabValue={setTabValue} />

      <Tabs
        aria-label={accountsCopy.transactions_and_details_aria}
        centered={true}
        onChange={(_, val) => setTabValue(val)}
        textColor="primary"
        value={tabValue}
        variant="fullWidth"
      >
        <Tab
          aria-controls="transaction-details-tabpanel-0"
          id="transaction-details-tab-0"
          label={accountsCopy.transactions}
        />
        <Tab
          aria-controls="account-details-tabpanel-1"
          id="account-details-tab-1"
          label={accountsCopy.account_details}
        />
      </Tabs>

      <TabContentContainer index={0} name="transaction-details" value={tabValue}>
        <TransactionsTab />
      </TabContentContainer>

      <TabContentContainer index={1} name="account-details" value={tabValue}>
        <AccountDetailsTab />
      </TabContentContainer>
    </>
  )
}

export default observer(AccountDetailsContent)
